var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgLocation = function SvgLocation(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 19C5.73694 17.9226 4.56619 16.7415 3.5 15.469C1.9 13.558 8.78894e-07 10.712 8.78894e-07 7.99997C-0.00069302 6.61493 0.409509 5.26082 1.17869 4.109C1.94788 2.95718 3.04147 2.05943 4.32107 1.52937C5.60067 0.999307 7.00875 0.86076 8.36712 1.13126C9.72548 1.40176 10.9731 2.06915 11.952 3.04897C12.6038 3.69783 13.1203 4.46951 13.4719 5.31934C13.8234 6.16918 14.0029 7.0803 14 7.99997C14 10.712 12.1 13.558 10.5 15.469C9.4338 16.7415 8.26306 17.9226 7 19ZM7 4.99997C6.20435 4.99997 5.44129 5.31604 4.87868 5.87865C4.31607 6.44126 4 7.20432 4 7.99997C4 8.79562 4.31607 9.55868 4.87868 10.1213C5.44129 10.6839 6.20435 11 7 11C7.79565 11 8.55871 10.6839 9.12132 10.1213C9.68393 9.55868 10 8.79562 10 7.99997C10 7.20432 9.68393 6.44126 9.12132 5.87865C8.55871 5.31604 7.79565 4.99997 7 4.99997Z",
    fill: "#354152"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgLocation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "dist/media/location.c098b237af323cc839bc9f73ac0ac691.svg";